import Vue from 'vue'
import Router from 'vue-router'

// Components
import Home from '@/components/Home'
import NotFound from '@/components/NotFound'
import SignIn from '@/components/Admin/SignIn'
import Dashboard from '@/components/Admin/Dashboard'
import Users from '@/components/Admin/Users'
import UserView from '@/components/Admin/UserView'
import UpdateDuePayment from '@/components/Admin/UpdateDuePayment'
import Cities from '@/components/Admin/Cities'
import CityEdit from '@/components/Admin/CityEdit'
import CityAdd from '@/components/Admin/CityAdd'
import Businesses from '@/components/Admin/Businesses'
import BusinessAdd from '@/components/Admin/BusinessAdd'
import BusinessEdit from '@/components/Admin/BusinessEdit'
import BusinessView from '@/components/Admin/BusinessView'
import Dishes from '@/components/Admin/Dishes'
import DishAdd from '@/components/Admin/DishAdd'
import DishEdit from '@/components/Admin/DishEdit'
import DishView from '@/components/Admin/DishView'
import InstantDishes from '@/components/Admin/InstantDishes'
import Orders from '@/components/Admin/Orders'
import OrderView from '@/components/Admin/OrderView'
import PasswordUpdate from '@/components/Admin/PasswordUpdate'
import Countries from '@/components/Admin/Countries'
import CountryAdd from '@/components/Admin/CountryAdd'
import CountryEdit from '@/components/Admin/CountryEdit'
import CountryDelete from '@/components/Admin/CountryDelete'
import Configurations from '@/components/Admin/Configurations'
import PushNotifications from '@/components/Admin/PushNotifications'
import DishesSort from '@/components/Admin/DishesSort'
import Verifications from '@/components/Admin/Verifications'
//import Migrate from '@/components/Tools/Migrate'

Vue.use(Router)

export default new Router({

  // Config
  mode: 'history',

  // Routes
  routes: [
    { path: '/', name: 'Home', component: Home },
    { path: '/aa-admin', name: 'SignIn', component: SignIn },
    { path: '/aa-admin/dashboard', name: 'Dashboard', component: Dashboard },
    { path: '/aa-admin/users', name: 'Users', component: Users },
    { path: '/aa-admin/:userKey/user', name: 'UserView', component: UserView },
    { path: '/aa-admin/:userKey/duepayment/update', name: 'UpdateDuePayment', component: UpdateDuePayment },

    { path: '/aa-admin/cities', name: 'Cities', component: Cities },
    { path: '/aa-admin/city/:countryKey/:cityKey', name: 'CityEdit', component: CityEdit },
    { path: '/aa-admin/city', name: 'CityAdd', component: CityAdd },
    { path: '/aa-admin/businesses/:lang?', name: 'Businesses', component: Businesses },
    { path: '/aa-admin/:userKey/business/add', name: 'BusinessAdd', component: BusinessAdd },
    { path: '/aa-admin/:businessKey/business/edit', name: 'BusinessEdit', component: BusinessEdit },
    { path: '/aa-admin/:businessKey/business/view', name: 'BusinessView', component: BusinessView },
    { path: '/aa-admin/dishes/:lang?', name: 'Dishes', component: Dishes },
    { path: '/aa-admin/:userKey/:businessKey/dish/add', name: 'DishAdd', component: DishAdd },
    { path: '/aa-admin/:userKey/:businessKey/dishes/order', name: 'DishesSort', component: DishesSort },
    { path: '/aa-admin/:userKey/:businessKey/:dishKey/dish/edit', name: 'DishEdit', component: DishEdit },
    { path: '/aa-admin/:userKey/:businessKey/:dishKey/dish/view', name: 'DishView', component: DishView },
    { path: '/aa-admin/instant-dishes', name: 'InstantDishes', component: InstantDishes },
    { path: '/aa-admin/orders', name: 'Orders', component: Orders },
    { path: '/aa-admin/:userKey/:orderKey/order/view', name: 'OrderView', component: OrderView },
    { path: '/aa-admin/password/update', name: 'PasswordUpdate', component: PasswordUpdate },
    { path: '/aa-admin/countries', name: 'Countries', component: Countries },
    { path: '/aa-admin/country/add', name: 'CountryAdd', component: CountryAdd },
    { path: '/aa-admin/:countryKey/country/edit', name: 'CountryEdit', component: CountryEdit },
    { path: '/aa-admin/:countryKey/country/delete', name: 'CountryDelete', component: CountryDelete },
    { path: '/aa-admin/configurations', name: 'Configurations', component: Configurations },
    { path: '/aa-admin/push', name: 'PushNotifications', component: PushNotifications },
    { path: '/aa-admin/verifications', name: 'Verifications', component: Verifications },

    // Migration
    //{ path: '/migrate', name: 'Migrate', component: Migrate },

    // Error routes
    { path: '*', name: 'NotFound', component: NotFound },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js